import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'

const Logo = ({ onClick }) => (
  <img
    onClick={onClick}
    src="/logo.svg?v=20260528"
    alt="Эффективный город"
    width="72"
    height="72"
  />
)

Logo.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

Logo.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(Logo)
